import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Table
} from 'react-bootstrap';
import Loader from '../components/Loader/Loader';
import {
  apiNotificationSettings,
  apiUpdateNotificationSettings
} from '../helpers/api';
import { ToggleRow } from './';


// removed 'Requests status & comments' settings for now as not needed
// { label: 'Requests status & comments', app: 'request_status_and_comments_app', email: 'request_status_and_comments_email', value: false },  
const settings = [
  { label: 'Render status', app: 'render_status_app', email: 'render_status_email', value: false },
  { label: 'Preview Status', app: 'preview_app', email: 'preview_email', value: false },
  { label: 'Shared files', app: 'shared_files_app', email: 'shared_files_email', value: false },
  {
    label: 'Updates/Announcement from imagine.io',
    app: 'update_or_announcement_from_live_furnish_app',
    email: 'update_or_announcement_from_live_furnish_email',
    value: false,
  },
  {
    label: 'Request',
    app: 'request_v2_app',
    email: 'request_v2_email',
    value: false,
  },
];

export default function Notifications() {
  const [emailToggle, setEmailToggle] = useState(false);
  const [appToggle, setAppToggle] = useState(false);
  const [notificationSettings, setNotificationSettings] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getNotificationSettings();
  }, []);

  function getNotificationSettings() {
    setLoading(true);
    apiNotificationSettings().then((response) => {
      setNotificationSettings(response.data);
    }).finally(() => setLoading(false));
  }

  const onToggle = (tag, checked) => {
    let formData = new FormData();
    formData.append(tag, checked.target.checked);
    apiUpdateNotificationSettings(formData).then((response) => {
      setNotificationSettings(response.data);
    });
  };

  const allAppToggle = (tag, checked) => {
    let formData = new FormData();
    formData.append('render_status_app', checked.target.checked);
    formData.append('preview_app', checked.target.checked);
    // formData.append('request_status_and_comments_app', checked.target.checked);
    formData.append('shared_files_app', checked.target.checked);
    formData.append('update_or_announcement_from_live_furnish_app', checked.target.checked);
    formData.append('request_v2_app', checked.target.checked);
    apiUpdateNotificationSettings(formData).then((response) => {
      setNotificationSettings(response.data);
    });
  };

  const allEmailToggle = (tag, checked) => {
    let formData = new FormData();
    formData.append('render_status_email', checked.target.checked);
    formData.append('preview_email', checked.target.checked);
    // formData.append('request_status_and_comments_email', checked.target.checked);
    formData.append('shared_files_email', checked.target.checked);
    formData.append('update_or_announcement_from_live_furnish_email', checked.target.checked);
    formData.append('request_v2_email', checked.target.checked);
    apiUpdateNotificationSettings(formData).then((response) => {
      setNotificationSettings(response.data);
    });
  };

  const allEmails = _.chain(notificationSettings)
    .reduce((result, value, key) => {
      if (_.endsWith(key, '_email')) {
        return [...result, value];
      }
      return result;
    }, [])
    .every((o) => o)
    .value();

  const allApp = _.chain(notificationSettings)
    .reduce((result, value, key) => {
      if (_.endsWith(key, '_app')) {
        return [...result, value];
      }
      return result;
    }, [])
    .every((o) => o)
    .value();

  if (loading) return <Loader loading backdrop />;

  return (
    <>
      <div className="bg-container">
        <div className="notif-container p-4 bg-white mb-3">
          <div className="notif-heading">
            <h6>Notification Settings</h6>
            {/* <p>Turn promotional email notifications from imagine.io on or off</p> */}
          </div>

          <div className="notification-manage d-flex flex-column mt-3">
            <div className="table-layout p-2">
              <Table striped>
                <thead>
                  <tr>
                    <th>I want to receive:</th>
                    <th>Application</th>
                    <th>Email</th>
                  </tr>  
                </thead>
                <tbody>
                  <ToggleRow
                    name="Activate all"
                    toggle1={{
                      checked: appToggle || allApp,
                      toggleId: 'allAppToggle',
                      onChange: allAppToggle,
                    }}
                    toggle2={{
                      checked: emailToggle || allEmails,
                      toggleId: 'allEmailToggle',
                      onChange: allEmailToggle,
                    }}
                  />
                  {settings.map((item, index) => {
                    return (
                      <ToggleRow
                        key={index}
                        name={item.label}
                        index={index}
                        toggle1={{
                          onChange: onToggle,
                          toggleId: item.app,
                          checked: notificationSettings[item.app],
                          tag: item.app,
                        }}
                        toggle2={{
                          onChange: onToggle,
                          toggleId: item.email,
                          checked: notificationSettings[item.email],
                          tag: item.email,
                        }}
                      />
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
